import clsx from 'clsx';
import React from 'react';
import styles from './Button.module.scss';

const Button = ({
  variant = 'primary',
  outlined,
  children,
  onClick,
  width,
  disabled = false,
  dataSentryElement,
}: {
  variant?: 'primary' | 'secondary' | 'success' | 'error';
  outlined?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  width?: string;
  disabled?: boolean;
  /**
   * Stable name of the action this button performs, read by the Sentry SDK instead of the
   * styled class. The class changes on every rebuild and means nothing in a replay; the marker
   * is what turns a click into a named action a reader can understand.
   */
  dataSentryElement?: string;
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      data-sentry-element={dataSentryElement}
      className={clsx(
        styles.wrapper,
        styles[variant],
        outlined && styles.outlined,
        disabled && styles.disabled
      )}
      style={{ width: width ? width : '' }}
    >
      {children}
    </button>
  );
};

export default Button;
